import { useEffect, useState } from "react";
import { Link, useLocation } from "@tanstack/react-router";
import { Phone, Search } from "lucide-react";

/**
 * Flytande CTA-rad på mobil: ring säljaren eller hoppa till lagret.
 * Visas efter lite scroll, döljs på formulär-/kontosidor och i forumets skrivläge.
 */
const HIDDEN_PREFIXES = ["/login", "/auth", "/konto", "/admin", "/forum/nytt", "/kontakt"];

export function MobileCallBar() {
  const [visible, setVisible] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onBar = (e: Event) => {
      const active = (e as CustomEvent<{ active: boolean }>).detail?.active;
      setBlocked(Boolean(active));
    };
    window.addEventListener("bottombar", onBar as EventListener);
    return () => window.removeEventListener("bottombar", onBar as EventListener);
  }, []);

  useEffect(() => {
    const onScroll = () => setVisible((window.scrollY || 0) > 420);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (blocked) return null;
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-40 lg:hidden transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-[130%]"
      }`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      aria-hidden={!visible}
    >
      <div className="mx-auto grid max-w-md grid-cols-[minmax(0,1fr)_auto] items-center gap-2 px-3 pb-3">
        <a
          href="tel:0708629743"
          className="inline-flex min-w-0 items-center justify-center gap-2 rounded-full bg-primary px-5 py-3.5 text-sm font-semibold text-primary-foreground shadow-2xl"
        >
          <Phone size={16} className="shrink-0" />
          <span className="truncate">Ring 070-862 97 43</span>
        </a>
        <Link
          to="/fordon"
          aria-label="Se lagret"
          className="grid h-[46px] w-[46px] shrink-0 place-items-center rounded-full border border-border bg-background/95 text-foreground shadow-xl backdrop-blur"
        >
          <Search size={17} />
        </Link>
      </div>
    </div>
  );
}
